"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePoolTokenPrice = void 0;
var bn_js_1 = __importDefault(require("bn.js"));
var hooks_1 = require("../../pool/hooks");
var hooks_2 = require("../../shared/hooks");
var utils_1 = require("../../shared/utils");
/**
 * Can be determined from a few source (in order of preference):
 * 1. from sale rate if it's running
 * 1. from public price provider, priceRefresher (both usd and currency MUST be specified)
 * 2. from PancakeSwap pair reserves
 * 3. from listing rate
 */
function usePoolTokenPrice() {
    var _a;
    var pool = (0, hooks_1.usePool)().pool;
    var token = pool.token;
    // const pairContract = usePairContract(token.pairAddress);
    var currencyUsdPrice = (0, hooks_1.usePoolCurrencyUsdPrice)();
    var publicPriceUsed = !!token.priceRefresher;
    // const pairPriceUsed = !publicPriceUsed && !!token.pairAddress;
    var pairPriceUsed = !publicPriceUsed;
    // 1. from public price provider
    var priceUsd = (0, hooks_2.usePriceFetcher)({
        price: (_a = token === null || token === void 0 ? void 0 : token.price) === null || _a === void 0 ? void 0 : _a.usd,
        priceRefresher: token === null || token === void 0 ? void 0 : token.priceRefresher,
    });
    var priceCurrency = 0;
    var publicPrices = {
        priceUsd: priceUsd,
        priceCurrency: new bn_js_1.default(priceCurrency),
        rate: pool.sale.rate,
    };
    // 2. from pair reserves
    // const pairPriceCurrency = useTokenPriceFromPair({
    //   pairContract,
    //   tokenDecimals: token.decimals,
    //   isActive: pairPriceUsed,
    // });
    // const pairPriceUsd = pairPriceCurrency.muln(currencyUsdPrice);
    // const pairPrices = {
    //   priceUsd: toEthN(pairPriceUsd, 8),
    //   priceCurrency: pairPriceCurrency,
    // };
    // 3. from sale rate
    var salePriceCurrency = (0, hooks_1.useSaleRate)().currencyPerToken;
    var salePriceUsd = salePriceCurrency.muln(currencyUsdPrice);
    var salePrices = {
        priceUsd: (0, utils_1.toEthN)(salePriceCurrency, 8),
        priceCurrency: salePriceUsd,
        rate: pool.sale.rate,
    };
    // If presale is not finished, use its rate
    if (!pairPriceUsed && !publicPriceUsed) {
        return salePrices;
    }
    if (publicPriceUsed) {
        return publicPrices;
    }
    else if (pairPriceUsed) {
        // return pairPrices;
        return publicPrices;
    }
    else {
        return salePrices;
    }
}
exports.usePoolTokenPrice = usePoolTokenPrice;
